import { Part } from '../../../../../graphql'

export default function getActions( canEdit: boolean, openEditModal: ( part: Part ) => void ) {
	return {
		actions: [
			{
				isPrimary: true,
				name: 'Edit',
				icon: 'pencil',
				type: 'icon',
				description: 'Edit Product',
				enabled: () => canEdit,
				onClick: openEditModal,
			}
		],
		name: 'Actions',
	}
}
